// ExistingCustomerStep1.jsx
import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'

import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'

import {
  CapitalButton,
} from '../../Navigation/Buttons'

import ModemAliasDefault from '../../Graphics/ModemSwapGraphics/ModemAlias'

import {
  TextInput,
} from '../../Inputs/Inputs'

// HOC
import withAppStore from '../../../../util/withAppStore'

import styles from '../../../../../css/home.module.css'
import settingStyles from '../../../../../css/settings.module.css'
import { swapModem } from '../../../../actions/actions'

const ModemReplacementStep4 = ({
  intl: { formatMessage, locale },
  data: { deviceSettings: { saved } = {} } = {},
  device,
  submitFinished,
}) => {
  const [language, setLanguage] = useState('')
  const [invalid, setInvalid] = useState(true)
  const [alias, setAlias] = useState('')
  const [errorMessage, setErrorMessage] = useState(false)
  const [errorMessageText, setErrorMessageText] = useState('')

  // Initialize language from intl
  useEffect(() => {
    setLanguage(locale || 'en')
  }, [locale])

  // Handle saved state changes
  useEffect(() => {
    let goBackOnce = false
    if (saved === true && !goBackOnce) {
      goBackOnce = true
      setTimeout(() => {
        isFinished()
      }, 2000)
    }
  }, [saved])

  const handleChange = useCallback((field, value) => {
    const newValue = value
    if (field === 'alias') {
      setAlias(newValue)
    }
  }, [])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  const isFinished = useCallback(() => {
    submitFinished()
  }, [submitFinished])

  const sendData = useCallback(() => {
    const deviceID = device.id
    const { address } = device

    const data = { alias, address }

    swapModem(
      deviceID,
      data,
      (error) => {
        if (error) {
          setInvalid(true)
          setErrorMessage(true)
          setErrorMessageText(typeof error === 'string' && error !== 'error'
            ? error
            : 'An error has occurred. This Alias may have already been entered. If not please contact Altrac Support.'
          )
        } else {
          setTimeout(() => {
            isFinished()
          }, 500)
        }
      }
    )
  }, [alias, device, isFinished])

  // Validate alias whenever it changes
  useEffect(() => {
    if (alias === '') {
      setInvalid(true)
      setErrorMessage(false)
    } else if (!alias.startsWith('A') && !alias.startsWith('B')) {
      setInvalid(true)
      setErrorMessage(true)
      setErrorMessageText('Modem Alias must begin with letter A or B.')
    } else if (alias.length !== 5) {
      setInvalid(true)
      setErrorMessage(true)
      setErrorMessageText('Modem Alias must be 5 characters in length.')
    } else {
      setInvalid(false)
      setErrorMessage(false)
    }
  }, [alias])

  let saveButtonStyle = `${styles.saveButton} saveButton`

  if (invalid) {
    saveButtonStyle = `${styles.saveButton} saveButton`
  } else if (saved === true) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonSuccess}`
  } else if (saved === 'error' || errorMessage) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonError}`
  }

  return (
    <div>
      <div className={`${styles.userInviteInput} ${settingStyles.modemReplacementContainer}`}>
        <FormattedMessage
          id='settings.modemReplacement.modemAliasHeader'
          defaultMessage='Locate the LTE modem alias on the modem board'
          description='Modem Alias Header label'
          tagName='p'
        />

        <div className={settingStyles.ModemSVGWrapper}>
          <ModemAliasDefault />
        </div>

        <section className={`${styles.userInput} ${settingStyles.modemSubmitWrapper}`}>

          <FormattedMessage
            id='settings.modemReplacement.modemAliasInputLabel'
            defaultMessage='Enter LTE modem alias'
            description='Modem Alias Input label'
            tagName='p'
          />
          <div className={styles.userInputValueEdit}>
            <TextInput
              value={alias.toUpperCase()}
              childChange={childChange}
              field='alias'
              placeholder='Modem Alias'
            />
          </div>
          {errorMessage && (
            <p className={settingStyles.errorMessage}>
              {errorMessageText}
            </p>
          )}
        </section>
      </div>

      <CapitalButton
        text={formatMessage({
          id: 'settings.modemReplacement.submit',
          defaultMessage: 'Submit',
          description: '',
        })}
        buttonFunction={sendData}
        hSize='h3'
        style={saveButtonStyle}
        disabled={invalid}
      />

      <CapitalButton
        text={formatMessage({
          id: 'settings.modemReplacement.exit',
          defaultMessage: 'Exit',
          description: '',
        })}
        buttonFunction={isFinished}
        hSize='h3'
        style={`${styles.exitButton} saveButton ${styles.saveButton}`}
      />
    </div>
  )
}

ModemReplacementStep4.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    locale: PropTypes.string,
  }),
  data: PropTypes.shape({
    deviceSettings: PropTypes.shape({
      saved: PropTypes.bool,
    }),
  }),
  device: PropTypes.object.isRequired,
  submitFinished: PropTypes.func.isRequired,
}

export default withAppStore(injectIntl(ModemReplacementStep4))
